export default function() {
  const widgetName = 'directions';
  const widgetOpts = directionsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'DIRECTIONS'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}